import { css } from 'lit';

export default css`
    @keyframes fade-slide-in {
        from {
            opacity: 0;
            transform: translateY(8px);
        }
    }

    .group:not(.animated) ki-ds-pwa-timeseries-list-item {
        animation: fade-slide-in 200ms ease-out calc(var(--i) * 50ms) both;
    }

    .location-title {
        color: var(--color-text-secondary);
        font-size: var(--font-size-headline-m);
        font-weight: var(--font-weight-head-s);
        padding: var(--metrics-spacing-l) var(--metrics-spacing-l) var(--metrics-spacing-s) var(--metrics-spacing-l);
    }

    .items {
        display: block;
    }
`;
